<template>
	<div class="tree_navigation">
		<el-tree 
			:data="area_data" 
			node-key="key"
			:accordion="true"
			:default-expand-all="false"
			:expand-on-click-node="false"
			:highlight-current="true"
			@node-click="handleNodeClick"
		>
		</el-tree>
	</div>
</template>

<script>
	import areaData from "v-distpicker/src/districts.js"
	
	export default {
		data () {
			return {
				area_data: []
			}
		},
		mounted () {
			this.formatData();
		},
		methods: {
			/* eslint-disable */
			formatData () {
				for (var k in areaData) {	// 遍历所有省份
					if (k == 100000) {
						for (var kk in areaData[k]) {
							var _child = {
								label: areaData[k][kk],
								key: kk,
								children: [],
								sign: "P"
							};
							this.area_data.push(_child);
						}
					}
				}
				for (var i = 0;i < this.area_data.length;i++) {	// 遍历所有市
					var _k = this.area_data[i]['key'];
					for (var k in areaData) {
						if (k == _k) {
							for (var kk in areaData[k]) {
								var _child = {
									label: areaData[k][kk],
									key: kk,
									children: [],
									sign: "C",
									parentKey: _k,
									parentLabel: this.area_data[i]['label']
								};
								this.area_data[i]['children'].push(_child);
							}
						}
					}
				}
				for (var i = 0;i < this.area_data.length;i++) {	// 遍历所有区
					for (var ii = 0;ii < this.area_data[i].children.length;ii++) {
						var _k = this.area_data[i].children[ii]['key'];
						for (var k in areaData) {
							if (k == _k) {
								for (var kk in areaData[k]) {
									var _child = {
										label: areaData[k][kk],
										key: kk,
										sign: "A",
										grandKey: this.area_data[i].key,
										grandLabel: this.area_data[i].label,
										parentKey: _k,
										parentLabel: this.area_data[i].children[ii].label
									};
									this.area_data[i]['children'][ii]['children'].push(_child);
								}
							}
						}
					}
				}
				this.area_data = [{
					label: "中国",
					key: null,
					sign: "country",
					children: this.area_data
				}];
			},
			handleNodeClick (data) {
				// console.log(data);
				this.$emit("nodeClick", data);
			}
		}
	}
</script>

<style>
	.business_manage_page .tree_navigation { position: absolute;width: 170px;top: 15px;left: 15px;bottom: 15px;padding: 15px 0;border: 1px solid #ccc;border-radius: 5px;background: #fff;overflow: auto; }
	.business_manage_page .tree_navigation::-webkit-scrollbar {display: none;}
	.business_manage_page .tree_navigation .el-tree-node__content>.el-tree-node__expand-icon { padding: 0 3px; }
</style>
